import React from "react";
import { useNavigate } from "react-router-dom";
import { Spinner } from "reactstrap";

export default function WritingPreviewProcessing({ url, statusLabel }) {
	const navigate = useNavigate();
	const label = statusLabel || "Preparing your AI writing preview";

	return (
		<div className="contentBlock ai-visibility-dashboard writing-preview-page">
			<div className="writing-preview__header">
				<div className="writing-preview__header-left">
					<button
						type="button"
						className="writing-preview__back"
						onClick={() => navigate("/aivisibility/writing-assistance")}
					>
						<i className="fas fa-arrow-left me-2" />
						Back
					</button>
					{url && (
						<a
							href={url}
							target="_blank"
							rel="noopener noreferrer"
							className="writing-preview__header-url"
							title={url}
						>
							{url}
						</a>
					)}
				</div>
				{statusLabel && (
					<span className="writing-preview__status-badge writing-preview__status-badge--processing">
						{statusLabel}
					</span>
				)}
			</div>

			<div className="writing-preview__processing">
				<Spinner color="primary" className="mb-3" />
				<p className="writing-preview__processing-title mb-1">{label}…</p>
				<p className="writing-preview__processing-subtitle text-muted mb-0">
					This may take a minute while we load and analyze your page.
				</p>
			</div>
		</div>
	);
}
